'use client';

import { AppConfigByCountry, AppUserInfo, ConfigByCountry, UserinfoRes } from '@/types/user';
import { useAppStore } from '@/store/app-store';

export const setUserInfo = (userinfoRes: UserinfoRes) => {
  const { userExtend, userType } = userinfoRes.userDetails || {};
  const { effectiveUser, isAnonymous } = userinfoRes.userContext || {};
  const isFullUser = userType.toLowerCase() === 'full';
  const isLightUser = userType.toLowerCase() === 'light';
  const appUserInfo: AppUserInfo = {
    ...userExtend,
    userType,
    effectiveUser,
    isAnonymous,
    isFullUser,
    isLightUser,
  };
  useAppStore.getState().setUserInfo(appUserInfo);
};

export const getAppConfigByCountry = (configByCountry: ConfigByCountry[]): AppConfigByCountry => {
  return {
    isShowDispatchNoteInOrder: getConfigEnabled(configByCountry, 'Download Dispatch Note PDF', 'Order'),
    isShowDownloadQuotationInCart: getConfigEnabled(configByCountry, 'Download Quotation', 'Cart'),
    isShowInvoiceInOrder: getConfigEnabled(configByCountry, 'Download Invoice PDF', 'Order'),
    isShowCancelOrder: getConfigEnabled(configByCountry, 'CancelOrder', 'Order'),
    isShowFWOInfo: getConfigEnabled(configByCountry, 'cart_promotion_fwo_info', 'cart_page'),
    isShowQTPDownload: getConfigEnabled(configByCountry, 'promotion_qtp_export', 'admin_promotion_list'),
  };
};

const getConfigEnabled = (
  configByCountry: ConfigByCountry[],
  name: ConfigByCountry['name'],
  pageLocation: ConfigByCountry['pageLocation']
): boolean => {
  return configByCountry.some((item) => item.name === name && item.pageLocation === pageLocation && item.enabled);
};
